import { filter, map } from 'lodash';
import { createElement } from 'react';
import AlertBox from '../../AlertBox';

export default function CycleCreateWarnings({ warnings, model, mode }) {
    const warningsToShow = filter(warnings, warning => {
        return warning.isShown && warning.isShown(model, mode);
    });

    if (!warningsToShow.length) {
        return <noscript />;
    }

    return (
        <div className="guided-cycle-create-warnings">
            {map(warningsToShow, (warning, key) => {
                return (
                    <AlertBox key={key} colour="RED">
                        {createElement(warning, { model, mode })}
                    </AlertBox>
                );
            })}
        </div>
    );
}
